// extracted by mini-css-extract-plugin
module.exports = {"topper":"topper_topper__1dND0","textBlock":"topper_textBlock__1cxTu"};